import { React, useState } from 'react'
import styled from 'styled-components'
import ProfileShort from '../components/shared/ProfileShort'
import ProductInfo from '../components/Product/ProductInfo'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchOneThing } from '../utils/services/fetchThing'
import { fetchUserPublicInfo } from '../utils/services/fetchUser'
import DeleteProduct from '../components/Product/DeleteProduct'
import SellProduct from '../components/Product/SellProduct'
import { fetchUserInfo } from '../utils/services/fetchUser'
import Sidebar from '../components/shared/Sidebar'

const StyledProduct = styled.div`
    display: flex;
`

function Product() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const { thingNumber } = useParams()

    const [isVisible, setIsDeleteVisible] = useState(false)
    const [isSoldVisible, setIsSoldVisible] = useState(false)

    // Get thing info
    const {
        data: thingInfo,
        isLoading: isLoadingThing,
        isError: isErrorThing,
    } = useQuery({
        queryKey: ['thingInfo', thingNumber],
        queryFn: () => fetchOneThing(thingNumber),
        staleTime: 1 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching thing info:', err)
        },
    })

    // Get seller public info, only if thingInfo is available
    const {
        data: sellerInfo,
        isLoading: isLoadingSeller,
        isError: isErrorSeller,
    } = useQuery({
        queryKey: ['sellerInfo', thingInfo?.userId],
        queryFn: () => fetchUserPublicInfo(thingInfo.userId),
        enabled: !!thingInfo?.userId, // Conditional fetching
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching seller info:', err)
        },
    })

    // Get user info
    const { data: userInfo } = useQuery({
        queryKey: ['userInfo'],
        queryFn: fetchUserInfo,
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching user info:', err)
        },
    })

    // Handle loading states
    if (isLoadingThing || isLoadingSeller) {
        return <div>Loading...</div>
    }

    // Handle error states
    if (isErrorThing) {
        return <div>Error fetching product information.</div>
    }
    if (isErrorSeller) {
        return <div>Error fetching seller information.</div>
    }

    return (
        <StyledProduct>
            {userInfo && (
                <Sidebar
                    setIsSidebarOpen={setIsSidebarOpen}
                    isSidebarOpen={isSidebarOpen}
                    userInfo={userInfo}
                />
            )}{' '}
            <ProfileShort userInfo={userInfo} sellerInfo={sellerInfo} />
            <ProductInfo
                userInfo={userInfo}
                sellerInfo={sellerInfo}
                thingInfo={thingInfo}
                setIsDeleteVisible={setIsDeleteVisible}
                setIsSoldVisible={setIsSoldVisible}
            />{' '}
            {/* Passing thingInfo to ProductInfo */}
            {isVisible && (
                <DeleteProduct
                    setIsDeleteVisible={setIsDeleteVisible}
                    thingInfo={thingInfo}
                />
            )}
            {isSoldVisible && (
                <SellProduct
                    setIsSoldVisible={setIsSoldVisible}
                    thingInfo={thingInfo}
                />
            )}
        </StyledProduct>
    )
}

export default Product
